import React from 'react'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll'

import { Link } from 'gatsby'
const Nav = (props) => (
    <nav id="nav" className={props.sticky ? 'alt' : ''}>
        <Scrollspy items={ ['intro', 'first', 'second', 'cta'] } currentClassName="is-active" offset={-300}>
            <li>
                <Scroll type="id" element="intro">
                    <a href="#">Big Five career test</a>
                </Scroll>
            </li>
            <li>
            <a href="https://archetypes.jilecek.cz">Jungian archetypes test</a>

            </li>


        </Scrollspy>
    </nav>
)

export default Nav
